import { W, H, F, CEIL, R, PROPS } from "./props";
import { DOOR_W, HOUSEMATES, SCENES, visible } from "./rooms";
import { DETAILS } from "./details";

const ALL_PROPS = { ...PROPS, ...DETAILS };

export const doorWidth = (d) => (d.kind && d.kind.startsWith("stairs") ? 28 : DOOR_W);

const LIGHTS = { receptiondesk: [16, 34, F - 30], fireplace: [22, 75, F - 18], lamp: [4, 48, F - 44], ceilinglamp: [0, 58, CEIL + 22], chandelier: [0, 66, CEIL + 22], bulb: [0, 48, CEIL + 22],
  furnace: [18, 40, F - 18], tv: [14, 30, F - 18], sconce: [3, 40, 62], nightstand: [7, 26, F - 28], candles: [12, 34, F - 30], stairsdown: [20, 30, F - 20], altarstone: [20, 40, F - 20], doorlight: [7, 30, F - 60], books: [16, 30, F - 14], firepit: [15, 26, F - 8], keystone: [12, 28, F - 14] };

function snow(ctx, x, y, w, h, t, n, big) {
  const gust = Math.sin(t / 1800) * 0.03 + 0.05;
  for (let i = 0; i < n; i++) {
    const sp = 0.02 + (i % 5) * 0.008;
    const fx = (((i * 73.13 + t * gust * (1 + (i % 3))) % w) + w) % w;
    const fy = (i * 41.7 + t * sp) % h;
    const s = big && i % 6 === 0 ? 2 : 1;
    R(ctx, i % 4 ? "#e8f1ff" : "#b6c7dc", x + fx, y + fy, s, s);
  }
}

function drawWindow(ctx, sx, t, curtain) {
  const y = 48, w = 34, h = 40;
  R(ctx, "#1f140c", sx - 3, y - 3, w + 6, h + 6);
  ctx.save(); ctx.beginPath(); ctx.rect(sx, y, w, h); ctx.clip();
  R(ctx, "#0a1424", sx, y, w, h); R(ctx, "#101d33", sx, y + 18, w, h - 18);
  for (let i = 0; i < 4; i++) { const tx = sx + 3 + i * 9; R(ctx, "#08101c", tx, y + 16 - (i % 2) * 4, 5, 18); }
  R(ctx, "#8ea4bb", sx, y + h - 7, w, 7);
  snow(ctx, sx, y, w, h, t, 34, false);
  if (Math.sin(t / 2600) > 0.985) R(ctx, "rgba(220,235,255,0.35)", sx, y, w, h);
  ctx.restore();
  R(ctx, "#1f140c", sx + w / 2 - 1, y, 2, h); R(ctx, "#1f140c", sx, y + h / 2 - 1, w, 2);
  R(ctx, "#d9e4ee", sx, y + h - 2, w, 2); R(ctx, "#2a1b10", sx - 5, y + h + 3, w + 10, 3);
  R(ctx, "#cfe4f5", sx + 1, y + 1, 4, 2); R(ctx, "#cfe4f5", sx + w - 5, y + 1, 4, 2);
  if (!curtain) return;
  const sway = Math.round(Math.sin(t / 1300) * 1);
  R(ctx, "#2a1a10", sx - 8, y - 7, w + 16, 2);
  [[sx - 7, 1], [sx + w - 1, -1]].forEach(([cx, d]) => {
    R(ctx, curtain, cx, y - 5, 8, h + 14); R(ctx, "rgba(0,0,0,0.35)", cx + 2, y - 5, 1, h + 14); R(ctx, "rgba(0,0,0,0.35)", cx + 5, y - 5, 1, h + 10);
    R(ctx, curtain, cx + (d > 0 ? 6 : -2) + sway, y + h + 2, 4, 6);
  });
  R(ctx, "#0a0a0a", sx - 6, y + h + 6, 3, 3);
}

function drawDoor(ctx, d, sx, t) {
  if (d.kind === "hidden") return;
  if (d.kind === "stairs_up") {
    R(ctx, "#0d0907", sx - 2, F - 64, 32, 64);
    for (let i = 0; i < 7; i++) R(ctx, i % 2 ? "#4a2e1b" : "#5a3a22", sx + i * 4, F - (i + 1) * 9, 30 - i * 4, 9);
    R(ctx, "#2a160a", sx - 2, F - 64, 2, 64); R(ctx, "#5a3a22", sx, F - 30, 28, 1);
    return;
  }
  if (d.kind === "stairs_down") {
    R(ctx, "#2a1d13", sx - 2, F - 56, 32, 56); R(ctx, "#030202", sx, F - 54, 28, 54);
    for (let i = 0; i < 6; i++) R(ctx, "#1f150d", sx + 2 + i * 4, F - 44 + i * 8, 26 - i * 4, 2);
    R(ctx, "#5a3a22", sx + 2, F - 40, 1, 40);
    return;
  }
  if (d.kind === "trail") {
    if (d.locked) { R(ctx, "#6b6f73", sx - 6, F - 16, 36, 1); for (let i = 0; i < 12; i++) R(ctx, "#9ca3af", sx - 6 + i * 3, F - 16 + (i % 2), 2, 2); R(ctx, "#2a1a10", sx - 8, F - 22, 3, 22); R(ctx, "#2a1a10", sx + 29, F - 22, 3, 22); R(ctx, "#990000", sx + 8, F - 18, 8, 6); }
    R(ctx, "#3a2414", sx + 9, F - 40, 3, 40); R(ctx, "#5a3a22", sx, F - 40, 24, 9); R(ctx, "#d9e4ee", sx, F - 41, 24, 2);
    R(ctx, "#f97316", sx + 3, F - 37, 12, 3); R(ctx, "#f97316", sx + 15, F - 38, 2, 5); R(ctx, "#f97316", sx + 17, F - 37, 2, 3);
    return;
  }
  if (d.kind === "iron") {
    R(ctx, "#1d1f21", sx - 3, F - 56, DOOR_W + 6, 56); R(ctx, "#3a3d40", sx, F - 53, DOOR_W, 53);
    for (let i = 0; i < 5; i++) { R(ctx, "#6b6f73", sx + 2, F - 50 + i * 11, 1, 1); R(ctx, "#6b6f73", sx + DOOR_W - 3, F - 50 + i * 11, 1, 1); }
    for (let i = 0; i < 11; i++) { R(ctx, "#8a8a8a", sx + i * 2, F - 40 + i * 2, 2, 2); R(ctx, "#8a8a8a", sx + DOOR_W - 2 - i * 2, F - 40 + i * 2, 2, 2); }
    R(ctx, "#b08d3a", sx + 8, F - 32, 6, 6); R(ctx, "#111", sx + 10, F - 30, 2, 2);
    if (Math.sin(t / 400) > 0.97) R(ctx, "rgba(220,38,38,0.25)", sx, F - 2, DOOR_W, 2);
    return;
  }
  const front = d.kind === "front";
  R(ctx, "#1a0f08", sx - 3, F - 54, DOOR_W + 6, 54);
  R(ctx, front ? "#3a2414" : "#4a2e1b", sx, F - 51, DOOR_W, 51);
  if (front) {
    R(ctx, "#0a1424", sx + 6, F - 46, 10, 10); snow(ctx, sx + 6, F - 46, 10, 10, t, 6, false);
  } else {
    R(ctx, "#3b2414", sx + 3, F - 47, 7, 18); R(ctx, "#3b2414", sx + 12, F - 47, 7, 18);
  }
  R(ctx, "#3b2414", sx + 3, F - 25, 7, 20); R(ctx, "#3b2414", sx + 12, F - 25, 7, 20);
  R(ctx, "#b08d3a", sx + 17, F - 27, 2, 2);
}

function drawRoomShell(ctx, room, cam) {
  const th = room.theme, x0 = -cam, rw = room.width;
  R(ctx, "#050508", 0, 0, W, H);
  R(ctx, "#0c0907", x0, 0, rw, CEIL);
  R(ctx, th.wall, x0, CEIL, rw, F - CEIL);
  if (th.pattern === "logs") for (let y = CEIL + 6; y < F; y += 9) R(ctx, th.wallDark, x0, y, rw, 2);
  if (th.pattern === "stripes") for (let x = 0; x < rw; x += 12) R(ctx, th.wallDark, x0 + x, CEIL, 3, F - CEIL);
  if (th.pattern === "tile") {
    for (let y = F - 50; y < F; y += 8) R(ctx, th.wallDark, x0, y, rw, 1);
    for (let x = 0; x < rw; x += 8) R(ctx, th.wallDark, x0 + x, F - 50, 1, 50);
  }
  if (th.pattern === "concrete") for (let i = 0; i < rw / 2; i++) R(ctx, th.wallDark, x0 + ((i * 97) % rw), CEIL + ((i * 53) % (F - CEIL)), 2, 1);
  R(ctx, "#140e0a", x0, CEIL, rw, 3);
  if (th.pipes) { R(ctx, "#4a4a4a", x0, CEIL + 5, rw, 3); R(ctx, "#3a3a3a", x0, CEIL + 10, rw, 2); }
  if (th.wainscot) { R(ctx, th.wainscot, x0, F - 38, rw, 34); R(ctx, "#140e0a", x0, F - 40, rw, 2); for (let x = 6; x < rw; x += 20) R(ctx, "rgba(0,0,0,0.25)", x0 + x, F - 34, 14, 26); }
  for (let i = 0; i < rw / 60; i++) { const cx = x0 + ((i * 137 + 23) % rw), cy = CEIL + 8 + ((i * 71) % 60); R(ctx, "rgba(0,0,0,0.35)", cx, cy, 1, 6); R(ctx, "rgba(0,0,0,0.35)", cx + 1, cy + 5, 1, 5); R(ctx, "rgba(0,0,0,0.35)", cx - 1, cy + 9, 1, 4); }
  R(ctx, "#1c140e", x0, CEIL + 3, rw, 2);
  [x0, x0 + rw].forEach((ex, side) => { const d = side ? -1 : 1; for (let i = 0; i < 10; i++) { R(ctx, "rgba(200,200,210,0.22)", ex + d * i - (side ? 1 : 0), CEIL + 3, 1, 10 - i); R(ctx, "rgba(200,200,210,0.18)", ex, CEIL + 3 + i, d * (10 - i), 1); } });
  R(ctx, "#140e0a", x0, F - 4, rw, 4);
  R(ctx, th.floor, x0, F, rw, H - F);
  for (let y = F + 6, r = 0; y < H; y += 7, r++) {
    R(ctx, th.floorDark, x0, y, rw, 1);
    for (let x = (r % 2) * 14; x < rw; x += 28) R(ctx, th.floorDark, x0 + x, y - 6, 1, 6);
  }
  for (let i = 0; i < rw / 8; i++) R(ctx, "rgba(0,0,0,0.25)", x0 + ((i * 89) % rw), F + 2 + ((i * 37) % 30), 2 + (i % 3), 1);
  R(ctx, "rgba(0,0,0,0.35)", x0, F, rw, 2);
}

function drawOutside(ctx, room, cam, t, morning) {
  if (morning) { const g = ctx.createLinearGradient(0, 0, 0, F); g.addColorStop(0, "#5b6f8c"); g.addColorStop(1, "#c9b8b0"); ctx.fillStyle = g; ctx.fillRect(0, 0, W, F); }
  else { R(ctx, "#060b16", 0, 0, W, H); R(ctx, "#0b1424", 0, 60, W, F - 60); }
  if (morning) {
    for (let i = 0; i < 6; i++) { const x = ((i * 90 - cam * 0.15) % 540 + 540) % 540 - 90; for (let k = 0; k < 34; k++) R(ctx, "#7d8ca3", x + k * 2, 58 + Math.abs(k - 17) * 1.8, 2, F); R(ctx, "#eef2f7", x + 28, 58, 12, 3); }
    for (let i = 0; i < 14; i++) { const x = ((i * 31 - cam * 0.45) % 440 + 440) % 440 - 30; R(ctx, "#3f4d5c", x + 6, 104, 3, F - 104); for (let k = 0; k < 4; k++) R(ctx, "#4a5a6b", x + 7 - (2 + k * 3), 92 + k * 8, 4 + k * 6, 8); }
  } else {
    for (let i = 0; i < 8; i++) { const x = ((i * 61 - cam * 0.3) % 400 + 400) % 400 - 40; R(ctx, "#0e1a2c", x, 70 + (i % 3) * 6, 50, F - 70); }
    for (let i = 0; i < 10; i++) { const x = ((i * 47 - cam * 0.6) % 380 + 380) % 380 - 30; R(ctx, "#09111e", x + 6, 80, 6, F - 80); R(ctx, "#0c1626", x, 90 + (i % 2) * 8, 18, 20); }
  }
  const x0 = -cam;
  if (morning) R(ctx, "rgba(220,230,240,0.25)", 0, 60, W, F - 60);
  if (room.trail) { R(ctx, "#c8d6e3", 0, F, W, H - F); R(ctx, "#e8f1ff", 0, F, W, 2); for (let i = 0; i < 40; i++) R(ctx, "#a9bbcc", ((i * 37 - cam) % 340 + 340) % 340 - 10, F + 6 + (i * 13) % 28, 6, 1); return; }
  R(ctx, "#2e2015", x0 - 40, 10, 130, F - 10);
  for (let y = 16; y < F; y += 9) R(ctx, "#1f150d", x0 - 40, y, 130, 2);
  R(ctx, "#d9e4ee", x0 - 44, 6, 138, 5);
  R(ctx, "#0a1424", x0 + 70, 50, 12, 14); R(ctx, "#f59e0b", x0 + 71, 51, 10, 12); R(ctx, "#1f140c", x0 + 75, 50, 2, 14);
  R(ctx, "#c8d6e3", 0, F, W, H - F); R(ctx, "#e8f1ff", 0, F, W, 2);
  for (let i = 0; i < 40; i++) R(ctx, "#a9bbcc", ((i * 37 - cam) % 340 + 340) % 340 - 10, F + 6 + (i * 13) % 28, 6, 1);
}

function drawItem(ctx, it, sx, t) {
  const y = F - (it.y || 1) - 3;
  R(ctx, "#000", sx - 1, y - 1, 6, 5); R(ctx, it.color, sx, y, 4, 3);
  if (((t / 1400 + sx * 0.01) % 1) < 0.18) { R(ctx, "#fff", sx + 1, y - 3, 1, 1); R(ctx, "#fff", sx + 3, y - 2, 1, 1); }
}

export const DANA_PLAYER = { hair: "#1a1210", skin: "#c99a74", top: "#2f4a6b", legs: "#1f2430", long: true };
export function drawPlayer(ctx, sx, step, facing, moving, sp = { hair: "#2a1a10", skin: "#d9b48f", top: "#3f4a35", legs: "#1f2430" }) {
  const f = facing > 0;
  R(ctx, "rgba(0,0,0,0.4)", sx - 1, F - 1, 10, 2);
  R(ctx, sp.hair, sx + 1, F - 20, 6, 3); R(ctx, sp.skin, sx + 1, F - 17, 6, 5); R(ctx, sp.hair, f ? sx + 1 : sx + 6, F - 17, 1, sp.long ? 7 : 3);
  R(ctx, "#111", f ? sx + 5 : sx + 2, F - 15, 1, 1);
  R(ctx, sp.top, sx, F - 12, 8, 8); R(ctx, "rgba(0,0,0,0.2)", sx + 3, F - 12, 1, 8);
  const sw = moving ? (step % 2 ? 1 : -1) : 0;
  R(ctx, sp.top, f ? sx + 6 + sw : sx - 1 - sw, F - 11, 2, 6);
  R(ctx, sp.legs, sx + 1, F - 4, 2, 4 - (sw > 0 ? 1 : 0)); R(ctx, sp.legs, sx + 5, F - 4, 2, 4 - (sw < 0 ? 1 : 0));
}

function drawNpc(ctx, sx, sp, facing, t, lift = 0) {
  if (!sp.kid) return drawNpcBody(ctx, sx, sp, facing, t, lift);
  ctx.save(); ctx.translate(sx + 4, F); ctx.scale(0.72, 0.72); ctx.translate(-(sx + 4), -F);
  drawNpcBody(ctx, sx, sp, facing, t, lift); ctx.restore();
}

function drawNpcBody(ctx, sx, sp, facing, t, lift = 0) {
  const f = facing > 0, by = ((t + sx * 37) % 3000 < 1500 ? 0 : 1) - lift;
  R(ctx, "rgba(0,0,0,0.4)", sx - 1, F - 1, 10, 2);
  R(ctx, sp.hair, sx + 1, F - 20 + by, 6, 3); if (sp.long) R(ctx, sp.hair, f ? sx : sx + 6, F - 18 + by, 2, 8);
  R(ctx, sp.skin, sx + 1, F - 17 + by, 6, 5); R(ctx, sp.hair, f ? sx + 1 : sx + 6, F - 17 + by, 1, 2);
  R(ctx, "#111", f ? sx + 5 : sx + 2, F - 15 + by, 1, 1);
  if (sp.glasses) R(ctx, "#9ca3af", f ? sx + 4 : sx + 1, F - 15 + by, 3, 1);
  if (sp.hat) R(ctx, sp.hat, sx, F - 21 + by, 8, 3);
  R(ctx, sp.top, sx, F - 12 - lift, 8, 8); R(ctx, "rgba(0,0,0,0.25)", sx + 3, F - 12 - lift, 1, 8);
  if (sp.scarf) { R(ctx, sp.scarf, sx, F - 12 - lift + by, 8, 2); R(ctx, sp.scarf, f ? sx + 1 : sx + 5, F - 10 - lift, 2, 4); }
  if (sp.coat && !lift) R(ctx, sp.top, sx, F - 4, 8, 2);
  if (sp.plaid) for (let i = 0; i < 3; i++) R(ctx, "rgba(0,0,0,0.3)", sx, F - 11 + i * 3, 8, 1);
  R(ctx, sp.top, f ? sx + 6 : sx, F - 11 - lift, 2, 6);
  if (sp.mug && !lift) { R(ctx, "#e7e0c9", f ? sx + 8 : sx - 2, F - 8, 3, 3); if ((t / 400) % 2 < 1) R(ctx, "rgba(220,220,230,0.35)", f ? sx + 9 : sx - 1, F - 11, 1, 2); }
  if (lift) { R(ctx, WOOD_CHAIR, sx - 1, F - 15, 10, 2); R(ctx, sp.legs, f ? sx + 2 : sx, F - 16, 6, 3); R(ctx, sp.legs, f ? sx + 7 : sx - 1, F - 14, 2, 14); R(ctx, WOOD_CHAIR, f ? sx - 1 : sx + 7, F - 13, 2, 13); return; }
  R(ctx, sp.legs, sx + 1, F - 4, 2, 4); R(ctx, sp.legs, sx + 5, F - 4, 2, 4);
}
const WOOD_CHAIR = "#3b2516";

const PLAYER_SPRITE = { hair: "#2a1a10", skin: "#d9b48f", top: "#3f4a35", legs: "#1f2430" };
function drawGathering(ctx, sc, cam, t) {
  const people = [PLAYER_SPRITE, ...HOUSEMATES.map((n) => n.sprite)];
  sc.seats.forEach(([x, f, who], i) => drawNpc(ctx, x - cam, who ? (who === "Joe" ? PLAYER_SPRITE : HOUSEMATES.find((n) => n.name === who).sprite) : people[i], f, t, sc.lift));
}
function drawBowls(ctx, sc, cam) {
  sc.seats.forEach(([x]) => { R(ctx, "#c8c4b8", x - cam + 1, F - 24, 6, 3); R(ctx, "#7a4a2a", x - cam + 2, F - 24, 4, 1); });
}

let shade;
function drawDarkness(ctx, room, cam, px, facing, hasLight, t, st) {
  if (!shade) { shade = document.createElement("canvas"); shade.width = W; shade.height = H; }
  const s = shade.getContext("2d");
  s.globalCompositeOperation = "source-over"; s.clearRect(0, 0, W, H);
  const base = room.outside ? (st.morning ? 0.08 : 0.5) : room.floor === "basement" ? 0.85 : room.floor === "cave" ? 0.9 : room.floor === "office" ? 0.5 : 0.74;
  const dark = st.lightsOff && !room.outside ? Math.min(0.95, base + 0.1) : base;
  s.fillStyle = `rgba(2,2,6,${dark})`; s.fillRect(0, 0, W, H);
  s.globalCompositeOperation = "destination-out";
  const hole = (x, y, r, a = 1) => {
    const g = s.createRadialGradient(x, y, 2, x, y, r);
    g.addColorStop(0, `rgba(0,0,0,${a})`); g.addColorStop(1, "rgba(0,0,0,0)");
    s.fillStyle = g; s.fillRect(x - r, y - r, r * 2, r * 2);
  };
  const flick = 0.92 + Math.random() * 0.08;
  hole(px + 4, F - 10, 34 * flick, 0.9);
  if (hasLight) hole(px + 4 + facing * 40, F - 16, 62 * flick, 0.95);
  const ELECTRIC = ["lamp", "ceilinglamp", "bulb", "tv", "chandelier", "sconce"];
  room.props.forEach((p) => {
    const L = LIGHTS[p.type];
    if (!L || !visible(p, st.notes) || (st.lightsOff && ELECTRIC.includes(p.type))) return;
    const fl = p.type === "bulb" || p.type === "ceilinglamp" ? (Math.random() > 0.02 ? 1 : 0.3) : flick;
    hole(p.x - cam + L[0], L[2], L[1] * fl, 0.85);
  });
  room.windows.forEach((w) => hole(w.x - cam + 17, 68, 28, 0.5));
  if (st.scene) hole(SCENES[st.scene.key].x - cam, F - 26, 60, 0.85);
  else (room.npcs || []).forEach((n) => n.sprite && visible(n, st.notes) && hole(n.x - cam + 4, F - 12, 26, 0.6));
  ctx.drawImage(shade, 0, 0);
}

function drawMemory(ctx, t) {
  R(ctx, "#cfd6dc", 0, 0, W, H); R(ctx, "#b9c2ca", 0, 0, W, 30); R(ctx, "#a7b0b8", 0, F, W, H - F); R(ctx, "#9aa3ab", 0, F, W, 2);
  R(ctx, "#8b98a6", 40, 40, 60, 50); R(ctx, "#5d6d80", 42, 42, 56, 46); R(ctx, "#8b98a6", 69, 42, 2, 46);
  for (let i = 0; i < 26; i++) R(ctx, "rgba(220,230,240,0.7)", 42 + ((i * 23) % 56), 42 + ((i * 37 + t * 0.08) % 46), 1, 3);
  R(ctx, "#e8ecef", 150, F - 24, 90, 8); R(ctx, "#9aa3ab", 150, F - 16, 90, 3); R(ctx, "#6b7682", 152, F - 13, 3, 13); R(ctx, "#6b7682", 235, F - 13, 3, 13);
  R(ctx, "#6b7682", 150, F - 40, 3, 24); R(ctx, "#f5f7f8", 156, F - 30, 16, 6);
  R(ctx, "#e7c4a8", 160, F - 32, 8, 7); R(ctx, "#a85a7a", 159, F - 34, 10, 3); R(ctx, "#111", 162, F - 29, 1, 1); R(ctx, "#111", 165, F - 29, 1, 1);
  R(ctx, "#a9c4e0", 168, F - 30, 66, 7); R(ctx, "#93b0cf", 168, F - 25, 66, 2);
  R(ctx, "#9ca3af", 132, F - 70, 2, 70); R(ctx, "#9ca3af", 126, F - 70, 14, 2); R(ctx, "rgba(220,235,255,0.8)", 128, F - 68, 5, 10); R(ctx, "#9ca3af", 130, F - 58, 1, 30);
  R(ctx, "#4b5563", 250, F - 70, 30, 22); R(ctx, "#0b1a12", 252, F - 68, 26, 18);
  const ph = (t / 1100) % 1;
  for (let i = 0; i < 26; i++) { const spike = Math.abs(i / 26 - ph) < 0.04; R(ctx, "#4ade80", 252 + i, F - 59 - (spike ? 6 : 0), 1, spike ? 6 : 1); }
  R(ctx, "#6b7682", 264, F - 48, 2, 48);
  drawNpc(ctx, 136, PLAYER_SPRITE, 1, t, 0);
  R(ctx, "#e7c4a8", 146, F - 22, 6, 2); R(ctx, "#f9a8d4", 143, F - 8, 3, 1);
  const g = ctx.createRadialGradient(W / 2, H / 2, 50, W / 2, H / 2, 190);
  g.addColorStop(0, "rgba(255,255,255,0)"); g.addColorStop(1, "rgba(255,255,255,0.85)");
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
}

export function renderScene(ctx, st, room, t) {
  if (st.bg === "memory") { drawMemory(ctx, t); if (st.fade > 0) { ctx.fillStyle = `rgba(0,0,0,${st.fade})`; ctx.fillRect(0, 0, W, H); } return; }
  const cam = st.cam;
  if (room.outside) drawOutside(ctx, room, cam, t, st.morning); else drawRoomShell(ctx, room, cam);
  room.windows.forEach((w) => drawWindow(ctx, w.x - cam, t, room.theme?.curtain));
  room.doors.forEach((d) => visible(d, st.notes) && drawDoor(ctx, d, d.x - cam, t));
  const scn = st.scene && SCENES[st.scene.key];
  if (scn && scn.lift) drawGathering(ctx, scn, cam, t);
  room.props.forEach((p) => ALL_PROPS[p.type] && visible(p, st.notes) && ALL_PROPS[p.type](ctx, p.x - cam, p, t));
  if (scn && scn.bowls) drawBowls(ctx, scn, cam);
  if (scn && !scn.lift) drawGathering(ctx, scn, cam, t);
  if (!scn) (room.npcs || []).forEach((n) => n.sprite && visible(n, st.notes) && drawNpc(ctx, n.x - cam, n.sprite, st.x < n.x ? -1 : 1, t));
  room.items.forEach((it) => !st.inventory.includes(it.id) && visible(it, st.notes) && drawItem(ctx, it, it.x - cam, t));
  const dana = st.notes.includes("ch3:start") && !((st.notes.includes("living:event:joe3") && !st.notes.includes("chamber:event:agree")) || st.notes.includes("living:event:feel"));
  if (!scn) drawPlayer(ctx, st.x - cam, Math.floor(st.walk / 9), st.facing, st.moving, dana ? DANA_PLAYER : undefined);
  drawDarkness(ctx, room, cam, st.x - cam, st.facing, dana || st.inventory.includes("flashlight"), t, st);
  if (room.outside) snow(ctx, 0, 0, W, H, t, st.morning ? 40 : 160, true);
  if (st.fade > 0) { ctx.fillStyle = `rgba(0,0,0,${st.fade})`; ctx.fillRect(0, 0, W, H); }
}
